module.exports = __webpack_public_path__ + "img/verification-green.41f1a1bb.png";